export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Escribe una publicación...',
  blogsFeedSearchInputPlaceholder: 'Buscar',
  blogsFeedPostOwnerCurtainEditTitle: 'Editar publicación',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Eliminar publicación',
  blogsFeedEditedPostSavedAlertText: '¡Publicación guardada!',
  blogsFeedEditedPostDeletedAlertText: '¡Publicación eliminada!',
  blogsFeedShareCurtainOptionTitle: 'Copiar enlace',
  blogsFeedPostLinkCopiedAlertText: 'Enlace copiado!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Copiar enlace',
  blogsFeedOthersPosLinkCopiedAlertText: 'Enlace copiado!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Reportar contenido',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Eliminar publicación',
  blogsFeedPostDeletePopupTitle: 'Eliminar',
  blogsFeedPostDeletePopupText: '¿Estás seguro de que quieres eliminar esta publicación?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Cancelar',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Confirmar',
  blogsFeedPostDeeletedAlertText: '¡Publicación eliminada!',
  blogsPostDetailsHeaderTitle: 'Publicación',
  postFeedPostLikesText: 'Me gusta',
  postFeedPostCommentsText: 'Comentarios',
  postFeedPostNoLikesText: 'Todavía no hay me gusta',
  postFeedPostLeaveFirstLikeText: 'Puedes ser el primero en dar me gusta',
  blogsFeedPostDetailsNoCommentsText: 'Todavía no hay comentarios',
  blogsFeedPostDetailsFirstCommentText: 'Puedes ser el primero en comentar',
  blogsFeedPostDetailsShareOptionTitle: 'Copiar enlace',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Enlace copiado!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Copiar enlace',
  blogsFeedPostDetailsCopiedAlertText: 'Enlace copiado!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Reportar contenido',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Reportar',
  blogsPostDetailsReportedCurtainText: 'Contenido reportado',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Editar comentario',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Eliminar comentario',
  blogsPostDetailsEditedCommentSavedAlertText: '¡Comentario guardado!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Eliminar comentario',
  postDetailsOtherUsersCommentDeletadAlertText: '¡Comentario eliminado!',
  postDetailsDeleteCommentPopupTitle: 'Eliminar',
  postDetailsDeleteCommentPopupText: '¿Estás seguro de que quieres eliminar este comentario?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Cancelar',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirmar',
  postDetailsCommDeletedAlertText: '¡Comentario eliminado!',
  postDetailsCommentUserCurtainOptionTitle: 'Reportar comentario',
  blogsCreatePostCurtainTitle: 'Nueva publicación',
  blogsCreatePostCurtainBodyPlaceholder: 'Escribe tu texto aquí...',
  blogsCreatePostPublishButtonTitle: 'Publicar',
  blogsCreatePostUploadSlallerImageAlertText: 'Puedes subir un máximo de {size} MB a la vez',
  blogsPostSavedAlertText: '¡Publicación guardada!',
  blogsCreatePostAddLocationCurtainTitle: 'Ubicación',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Nombre de la ubicación',
  blogsCreatePostEditLocationCurtainText: 'Editar ubicación',
  blogsDeleteLocation: 'Eliminar ubicación',
  blogsDiscardPostPopupTitle: 'Descartar',
  blogsDiscardPostPopupText: '¿Deseas descartar este borrador?',
  blogsDiscardPostPopupCancelButtonTitle: 'Cancelar',
  blogsDiscardPostPopupCofirmButtonTitle: 'Confirmar',
  blogsNewPostCreatePollTitle: 'Crear encuesta',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Título',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Opción',
  blogsNewPostCreatePollAddButtonTitle: 'Agregar opción',
  blogsNewPostCreatePollCreateButtonTitle: 'Crear',
  blogsCreatePostPollTitleBlankAlertText: 'El título no puede estar en blanco!',
  blogsCreatePostPollOptionBlankAlertText: 'La opción no puede estar en blanco!',
  blogsCreatePostPollLongTitleAlertText: 'El título debe contener como máximo {length} caracteres',
  blogsCreatePostPollLongOptionAlertText: 'La opción debe contener como máximo {length} caracteres',
  blogsCreatePostPollEditOptionTitle: 'Editar encuesta',
  blogsCreatePostPollRemoveOptionTitle: 'Eliminar encuesta',
  blogsPostPollInfoVotesText: 'votos',
  blogsPostPollInfoEditVoteText: 'Editar voto',
  blogsPostPollFinishPollText: 'Finalizar encuesta',
  blogsPostPollFinishedPollText: 'Finalizada',
  blogsPostPollInProgresslText: 'En curso',
  blogsFinishPollCurtainTitle: 'Finalizar encuesta',
  blogsFinishPollCurtainText: 'Los usuarios no podrán votar después de que la encuesta haya finalizado.',
  blogsFinishPollCurtainCancelButtonTitle: 'Cancelar',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Confirmar',
  blogsPollInfoPollVotesCurtainTitle: 'Votos de la encuesta',
  blogsEditPostCurtainTitle: 'Editar publicación',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Escribe tu texto aquí...',
  blogsEditPostCurtainSaveButtonTitle: 'Guardar',
  blogsEditPostSavedAlertText: '¡Publicación guardada!',
  blogsError: '¡Algo salió mal!',
  blogsAt: 'a las',
  blogsSeeMore: 'Ver más...',
  blogsMaxAttachments: 'Has excedido el número máximo de archivos adjuntos. El máximo es {length}',
  blogsReply: 'Responder',
  blogsAddCover: 'Agregar imagen de portada'
}
